import { CONTINGENT_FILTERS, CONTINGENT_SCHEDULE_WHEN, CONTINGENT_SEARCH_MAX, CONTINGENT_TABS, isAdminRole } from "@seagames/contracts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { ContingentDashboard } from "../../components/contingent/contingent-dashboard";

const lenient = <T extends z.ZodTypeAny>(schema: T) => schema.optional().catch(undefined);

/**
 * Sector 4 · Contingent Dashboard (`contingent` NOC module, so a NOC below
 * Sector 4 gets the "not open yet" screen from the shell). A NOC sees its own
 * delegation; ADMIN / SUPER_ADMIN pick one (`org`). URL = the page's state:
 * the admin's pick, the tab, the tile (filter), the name search and the
 * schedule's filters.
 */
export const Route = createFileRoute("/_app/contingent")({
	validateSearch: z.object({
		org: lenient(z.string().uuid()),
		filter: lenient(z.enum(CONTINGENT_FILTERS)),
		q: lenient(z.string().trim().min(1).max(CONTINGENT_SEARCH_MAX)),
		tab: lenient(z.enum(CONTINGENT_TABS)),
		// The schedule tab: when, medal events only, one games-local day.
		when: lenient(z.enum(CONTINGENT_SCHEDULE_WHEN)),
		medal: lenient(z.boolean()),
		day: lenient(z.string().regex(/^\d{4}-\d{2}-\d{2}$/)),
	}),
	beforeLoad: ({ context }) => {
		const role = context.session.active_role;
		if (role !== "ORGANIZATION" && !isAdminRole(role)) throw redirect({ to: "/" });
	},
	staticData: { contentWidth: "full" },
	component: ContingentPage,
});

function ContingentPage() {
	const { session } = Route.useRouteContext();
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	return <ContingentDashboard session={session} search={search} onSearch={(patch) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })} />;
}
